// extracted by mini-css-extract-plugin
export var actions = "_2e-0";
export var actionsContainer = "_2e-7";
export var border = "_2e-1";
export var childFullHeight = "_2e-f";
export var collapse = "_2e-2";
export var content = "_2e-a";
export var contentChild = "_2e-e";
export var fullscreen = "_2e-c";
export var hasLeftRadius = "_2e-k";
export var headerContainer = "_2e-3";
export var headerRow = "_2e-5";
export var hidePadding = "_2e-b";
export var navCollapsedGap = "_2e-l";
export var noScrollX = "_2e-m";
export var noScrollY = "_2e-n";
export var noTopPadding = "_2e-i";
export var optOutTopPadding = "_2e-d";
export var pageMain = "_2e-j";
export var pageOuter = "_2e-g";
export var pagePadding = "_2e-8";
export var pageScroll = "_2e-9";
export var profile = "_2e-o";
export var profileContainer = "_2e-p";
export var profileImage = "_2e-q";
export var profileMain = "_2e-r";
export var profileSubtitle = "_2e-t";
export var profileTitle = "_2e-s";
export var showLeftPadding = "_2e-h";
export var tabsPortalSlot = "_2e-6";
export var tabsWrapper = "_2e-4";
export var title = "_2e-u";